<template>
  <b-container>
    <h3>{{ getContentItem("ordersButton") }}</h3>
    <DnTable
      class="blue"
      stacked="md"
      hover
      striped
      show-empty
      :items="orders"
      :busy="isOrdersLoading"
      :fields="OrderResultsColumns"
      :no-provider-filtering="true"
      :no-provider-sorting="true"
      :no-provider-paging="true"
    >
      <template #OrderNumber="{ row }">
        <router-link
          :to="{ name: 'OrderDetails', query: { orderNumber: row.item.OrderNumber, orderSource: row.item.OrderSource, dealerCode: row.item.DealerCode, salesOrg: row.item.SalesOrganization }}"
        >
          {{ row.item.OrderNumber }}
        </router-link>
      </template>
      <template #SubTotal="{ row }">
        <currency-text v-if="!hasPermission('HideInvoicePricing')" :amount="row.item.SubTotal" :currency-code="row.item.CurrencyCode" />
      </template>
      <template #empty>
        <div v-if="isOrdersLoading" class="d-flex justify-content-center">
          <loading-spinner />
        </div>
      </template>
    </DnTable>
  </b-container>
</template>

<script>
  import { mapGetters } from "vuex"

  import { constants } from "@/const"
  import { ErrorLogService } from "@/services/ErrorLogService"
  import { InvoiceService } from "@/services/InvoiceService"
  import { OrderService } from "@/services/OrderService"
  import { BackorderService } from "@/services/BackorderService"

  import { stringHelper } from "@/components/mixins/stringHelper"
  import { formatDateTime } from "@/components/mixins/formatDateTime"

  import CurrencyText from "@/components/Elements/CurrencyText"
  import LoadingSpinner from "@/components/Elements/LoadingSpinner"

  import OrdersSearchWidgetForm from "@/components/SubMenus/OrdersSearchWidgetForm"
  import DnTable from "@/components/Elements/DnTable/DnTable.vue";

  export default {
    components: {
      CurrencyText,
      LoadingSpinner,
      DnTable
    },
    mixins: [stringHelper, formatDateTime],
    props: {
      documentNumber: {
        type: String,
        default: "",
      },
      partNumber: {
        type: String,
        default: "",
      },
      dealerCodes: {
        type: Array,
        default: () => []
      },
    },
    data: () => ({
      OrderResultsColumns: [
        { key: "OrderNumber", localizationKey: "orderNumber" },
        { key: "SalesOrganization", localizationKey: "salesOrg" },
        { key: "DealerPurchaseOrder", localizationKey: "poNumber" },
        { key: "OrderDate", localizationKey: "date", formatter: "formatDateTime" },
        { key: "OrderStatus", localizationKey: "status" },
        { key: "ShipmentType", localizationKey: "orderType" },
        { key: "SubTotal", localizationKey: "total" },
      ],
      isOrdersLoading: true,
      orders: []
    }),
    computed: {
      ...mapGetters(["getContentItem", "activeAccountId", "user", "hasPermission"]),
      SearchKeyword() {
        return this.documentNumber ? this.documentNumber : this.partNumber
      },
    },
    mounted() {
      this.OrderSearch();
      this.OrderResultsColumns = this.OrderResultsColumns.map(column => {
        if (typeof column === "object") {
          return Object.assign({}, column, { label: this.getContentItem(column.localizationKey) })
        }
        return column
      })
    },
    methods: {
      OrderSearch() {
        var dealerCodesToSearch = this.dealerCodes;
        
        // clear out any existing orders because we will be concatenating results if there are more than 100 dealers
        this.orders = [];

        var batchSize = constants.ORDERSEARCH_DEALERCODE_BATCHSIZE;
        const batches = [];
        
        // split dealer codes into batches of batchSize
        for (let i = 0; i < dealerCodesToSearch.length; i += batchSize) {
          batches.push(dealerCodesToSearch.slice(i, i + batchSize));
        }

        this.isOrdersLoading = true;

        // perform searches for each batch and combine results
        Promise.all(
          batches.map(dealersBatch =>
            OrderService.SearchOrdersByDocumentOrPart(
              this.activeAccountId,
              this.user.UserId,
              this.partNumber,
              this.documentNumber,
              dealersBatch
            )
              .then(response => response.data)
              .catch(err => {
                  ErrorLogService.LogException(err);
                  return [];
              })
          )
        )
          .then(results => {
            this.orders = [].concat(...results);
          })
          .finally(() => {
            this.isOrdersLoading = false;
          });
     }

    }
  }
</script>
